import React from 'react'
import RelatedLinks from './related-links.js'
import { filterArrayByType } from '../../utility'

export default ({ body, isInverse }) => {
  let data = filterArrayByType(body, 'related_links')
  
  if (data.length === 0) {
    return null
  }

  return <RelatedLinks title={data[0]?.primary?.related_links_header.text} links={data[0].items} isInverse={isInverse} />
}
